module.exports = __webpack_public_path__ + "static/media/edit-white.6a4ffda0.svg";